<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.tab-pane.card-body
    .d-flex.align-items-center
        header.flex-grow-1
            h2 {{ $t('tabs.rooms.title') }}
            p.text-muted.mb-0 {{ $t('tabs.rooms.subtitle') }}
        edit-room-modal(@input="(room) => protocol.data.rooms.push(room)")

    .alert.alert-danger.mt-4(v-if="protocol.output > 50")
        | Die Gesamt-Nennleistung beträgt über 50 kW ({{ protocol.output }} kW). Ein Luftverbund nach TRGI ist nicht möglich.

    .table-responsive.mt-4: table.table.table-striped.table-hover
        thead
            tr
                th Nr
                th Nutzung
                th Volumen
                th Eigenschaften
                th Aktionen
        tbody
            tr(v-for="(room, idx) in protocol.data.rooms")
                //- Nr
                td {{ idx + 1 }}

                //- Nutzung
                td
                    | {{ getRoomName(room.name) }}
                    div(v-if="room.fireplaces.length")
                        small
                            | {{ room.fireplaces[0].category }} - {{ room.fireplaces[0].class }}
                            |
                            | ({{ room.fireplaces[0].output }} kW)
                        br
                        small.mr-1 Feuerstätte:
                        edit-fireplace-modal.mr-1(v-model="room.fireplaces[0]", @input="(value) => setFireplace(idx, value)")
                        small |
                        a.link.small.ml-1(@click="setFireplace(idx, false)") löschen
                    div(v-else)
                        edit-fireplace-modal(@input="(value) => setFireplace(idx, value)")

                //- Volumen
                td {{ room.volume }} m³

                //- Eigenschaften
                td
                    small
                        | Verbrennungsluftraum: {{ room.isVlr ? 'ja' : 'nein' }}
                        br
                        template(v-if="room.isVlr") Tür: {{ getDoorDescription(room.doorType) }}

                //- Aktionen
                td
                    edit-room-modal(v-model="protocol.data.rooms[idx]")
                    button.btn.btn-sm.btn-secondary.mb-2(@click="protocol.data.rooms.splice(idx, 1)")
                        font-awesome-icon(icon="times")
                        span.d-none.d-sm-inline.ml-2 entfernen

            //- Empty Rooms Table
            tr(v-if="!protocol.data.rooms.length")
                td.text-center.my-2(colspan="5")
                    p: em Noch keine Räume angelegt
                    p Der erste Raum ist immer der Hauptaufstellungsraum mit der Hauptfeuerstätte.

    .text-info(v-if="!validRooms || !protocol.data.rooms[0].fireplaces.length")
        font-awesome-icon.mr-1(icon="exclamation-circle")
        | Sie benötigen mindestens den Aufstellraum und eine Feuerstätte um fortzufahren

    button.btn.btn-primary.mt-4(v-if="validRooms", @click="saveAndContinue") Speichern &amp; Weiter
</template>

<script>
import { doorTypes, roomNames } from '@/constants'
import { Protocol, Room } from 'trgi'

import EditFireplaceModal from '@/views/Protocols/Modals/EditFireplace'
import EditRoomModal from '@/views/Protocols/Modals/EditRoom'

export default {
    components: {
        EditRoomModal,
        EditFireplaceModal
    },
    props: {
        value: {
            type: Protocol,
            default: function () {
                return new Protocol()
            }
        }
    },
    data () {
        const protocol = new Protocol(this.value)

        return {
            protocol,
            roomNames,
            doorTypes
        }
    },
    computed: {
        validRooms () {
            return this.protocol.data.rooms.length
        }
    },
    watch: {
        // When Protocol gets modified on another Tab, refresh Local Protocol Variable
        value (value) {
            this.protocol = new Protocol(value)
        }
    },
    methods: {
        getRoomName (shortName) {
            if (!shortName) {
                return 'LEER'
            }
            // this should be put in an external lib
            if (shortName.length === 2) {
                return this.roomNames.find(e => e.value === shortName).text
            } else {
                // compatibility fallback for older protocols
                return shortName
            }
        },
        getDoorDescription (doorType) {
            // compatibility fallback for older protocols
            if (doorType === undefined) {
                doorType = null
            }

            // this should be put in an external lib
            return this.doorTypes.find(e => e.value === doorType).text
        },
        setFireplace (roomIdx, fireplace) {
            const room = this.protocol.data.rooms[roomIdx]

            // currently, rooms can only have one fireplace
            room.fireplaces = fireplace ? [fireplace] : []

            // update with $set to trigger Vue Array Change Detection
            this.$set(this.protocol.data.rooms, roomIdx, new Room(room))
        },
        saveAndContinue () {
            this.$emit('save', new Protocol(this.protocol))
        }
    }
}
</script>

<style lang="scss" scoped>
ul.fireplaces {
    padding-left: 1.6rem;
}

a.link {
    cursor: pointer;
}
</style>
